import { styledComponent } from '@hermes/web-components'

export const MainContainer = styledComponent('div')`
  display: flex;
  flex-direction: column;
  gap: 17px;
  width: 100%;
  `

export const HorizontalLine = styledComponent('div')`
  height: 1px;
  width: 100%;
  background-color: #D5DEF9;
  `

export const SelectContainer = styledComponent('div')`
  display: flex;
  gap: 42px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    gap: 8px;
    justify-content: space-between;
  }
  `

export const DropDownContainer = styledComponent('div')<{ isVisible: boolean; isHospital: boolean }>`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, 1fr);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  
  ${({ isHospital }) =>
    isHospital &&
    `
  @media (max-width: 970px) {
      grid-template-columns: repeat(3, 1fr);
  }
  `}

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const Link = styledComponent('a')`
  font-size: 15px;
  color: #11245A;
  text-decoration: underline;
  `

export const CustomMenuItems = styledComponent('div')`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  `
